import { render, staticRenderFns } from "./GreenSmileySVG.vue?vue&type=template&id=71308543&scoped=true&"
import script from "./GreenSmileySVG.vue?vue&type=script&lang=js&"
export * from "./GreenSmileySVG.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71308543",
  null
  
)

export default component.exports